import React from 'react';
import { Table, Form, Input, Descriptions } from 'antd';

const FormTextTable = ({ label, name, rows, columns, ...rest }) => {
  return (
    <Form.Item label={label} name={name}>
      <Table
        bordered
        pagination={false}
        dataSource={rows}
        columns={columns.map((col) => ({
          ...col,
          render: (text, record) => {
            // Rozlíšenie medzi editovateľnými a needitovateľnými bunkami
            if (col.editable) {
              return (
                <Form.Item
                  name={[name, record.key, col.dataIndex]}
                  style={{ marginBottom: 0 }}
                  rules={col.rules || []}
                >
                  <Input {...rest} />
                </Form.Item>
              );
            }
            return text; // Zobrazí statický text pre needitovateľné bunky
          },
        }))}
        rowKey="key"
      />
    </Form.Item>
  );
};

export default FormTextTable;
